"use client";

import "./home-bundles";

/**
 * Renders nothing — it exists so the home route's client chunk retains the
 * import above, which is what registers the namespaces in the browser.
 */
export default function HomeI18n() {
  return null;
}
